// Base
import { useEffect } from 'react'
import { useRouter } from 'next/router'

// Redux
import { useAppDispatch } from '@redux/hooks'
import { setCurrency, setPaymentTag } from '@redux/slices/visitorSlice'

// Components
import LoadingScreen from '@components/fullLoader/LoadingScreen'
import Vendors from '@components/app/Vendors'
import Message from './message/Message'
import ScreenBlock from '@components/screen-block/ScreenBlock'

// Helpers
import { trackPageView } from '@helpers/trackers'
import { isString } from '@helpers/typeCheck'
import { getLocationExchangeRate } from '@helpers/exchangeRate'

const Wrapper = ({ children }: { children: JSX.Element }) => {
  const router = useRouter()

  const dispatch = useAppDispatch()

  useEffect(() => {
    const handleRouteChange = (
      url: string,
      { shallow }: { shallow: boolean }
    ) => {
      if (!shallow) {
        trackPageView(url)
      }
    }

    router.events.on('routeChangeComplete', handleRouteChange)
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange)
    }
  }, [router.events])

  useEffect(() => {
    if (router.isReady) {
      if (router.query.tag) {
        sessionStorage.setItem('tag', router.query.tag as string)
      }

      const routerTag = sessionStorage.getItem('tag')

      if (isString(routerTag)) {
        dispatch(setPaymentTag(routerTag))
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.query])

  useEffect(() => {
    // if (process.env.NODE_ENV != 'development') {
    const storedipGeo = sessionStorage.getItem('ipGeo')

    if (storedipGeo) {
      const ipGeo = JSON.parse(storedipGeo)
      dispatch(setCurrency(ipGeo))
    } else {
      getLocationExchangeRate().then((ipGeo) => {
        dispatch(setCurrency(ipGeo))
        sessionStorage.setItem('ipGeo', JSON.stringify(ipGeo))
      })
    }
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div>
      <Message />
      <Vendors />
      <LoadingScreen />
      <ScreenBlock />
      {children}
    </div>
  )
}

export default Wrapper
